// extracted by mini-css-extract-plugin
export default {"card-wrapper":"settings_card-wrapper__d+H1q","reset-btn":"settings_reset-btn__-hErN","app-name":"settings_app-name__OfAku"};